exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-bar[data-v-6f9c882d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 6px 0 0;\n  border-top: 1px solid #d4d4d4;\n  border-bottom: 1px solid #d4d4d4;\n  overflow: hidden;\n  min-height: 55px;\n}\n.nav-bar-item[data-v-6f9c882d] {\n  max-width: 60px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.nav-bar .img-box[data-v-6f9c882d] {\n  text-align: center;\n}\n.nav-bar .img-icon[data-v-6f9c882d] {\n  width: 25px;\n  height: 25px;\n}\n.nav-bar .font-12[data-v-6f9c882d] {\n  padding-top: 2px;\n  word-break: break-all;\n}\n", ""]);

// exports
